// Landing "Más vendidos" (LA REAL): agregar a la bolsa, swatches, etiquetas de ranking y aparición al scroll.
import { CartAddEvent } from '@theme/events';

const root = document.documentElement;

// Etiquetas "#n Más vendido" en toda la página según el orden del ranking
function applyRankBadges() {
  const ranking = document.querySelector('[data-lr-bs-ranking]');
  if (!ranking) return;
  const limit = Number(ranking.dataset.badgeCount) || 0;
  const ranks = new Map();
  ranking.querySelectorAll('[data-lr-bs-card]').forEach((card, i) => ranks.set(card.dataset.handle, i + 1));
  document.querySelectorAll('[data-lr-bs-card]').forEach((card) => {
    const rank = ranks.get(card.dataset.handle);
    const media = card.querySelector('.lr-bs-card__media');
    if (!rank || rank > limit || !media || media.querySelector('.lr-bs-badge--rank')) return;
    const badge = document.createElement('span');
    badge.className = 'lr-bs-badge lr-bs-badge--rank';
    badge.textContent = `#${rank} ${ranking.dataset.badgeLabel || 'Más vendido'}`;
    media.prepend(badge);
  });
}

function bindReveal() {
  const cards = document.querySelectorAll('.lr-bs-card:not(.is-in)');
  if (!('IntersectionObserver' in window)) return cards.forEach((c) => c.classList.add('is-in'));
  const io = new IntersectionObserver(
    (entries) => entries.forEach((e) => {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    }),
    { threshold: 0.12 }
  );
  cards.forEach((c, i) => { c.style.transitionDelay = `${(i % 4) * 70}ms`; io.observe(c); });
}

if (!window.lrBsBound) {
  window.lrBsBound = true;

  document.addEventListener('click', async (event) => {
    // Swatch: cambia la variante que se agrega
    const sw = event.target.closest('.lr-bs-sw');
    if (sw) {
      event.preventDefault();
      const card = sw.closest('[data-lr-bs-card]');
      card.querySelectorAll('.lr-bs-sw').forEach((x) => x.classList.toggle('is-on', x === sw));
      card.querySelector('.lr-bs-quick').dataset.variantId = sw.dataset.variantId;
      return;
    }

    // Agregar a la bolsa con el mismo evento que usa el tema (abre el carrito lateral)
    const button = event.target.closest('.lr-bs-quick');
    if (!button || button.disabled) return;
    event.preventDefault();
    button.disabled = true;
    try {
      const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(button.dataset.variantId), quantity: 1 }] }),
      });
      if (!res.ok) throw new Error('add failed');
      const cart = await (await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`)).json();
      document.dispatchEvent(
        new CartAddEvent(cart, 'lr-bs', { source: 'lr-bs', itemCount: cart.item_count, variantId: button.dataset.variantId })
      );
      button.classList.add('is-done');
      setTimeout(() => button.classList.remove('is-done'), 1200);
    } catch (e) {
      // Si algo falla, llevamos a la ficha del producto para no perder la venta
      window.location.href = button.closest('[data-lr-bs-card]').querySelector('a').href;
    } finally {
      button.disabled = false;
    }
  });
}

root.classList.add('lr-bs-js');
applyRankBadges();
bindReveal();
// El editor de temas re-renderiza secciones sueltas
document.addEventListener('shopify:section:load', () => { applyRankBadges(); bindReveal(); });
